import { ChatBotSettingsFormValues } from "@jugl-web/domain-resources/chat-bot";
import { InteractiveContainer } from "@jugl-web/ui-components";
import { ColorPickerPopover } from "@jugl-web/ui-components/web/ColorPickerPopover/ColorPickerPopover";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

export const ChatAppearanceSection: FC = () => {
  const { t } = useTranslations();
  const { control } = useFormContext<ChatBotSettingsFormValues>();

  return (
    <div className="flex flex-col gap-4">
      <span className="ml-2 font-secondary text-sm text-dark-700">
        {t({
          id: "cx-ai-agents-page.chat-style",
          defaultMessage: "Chat Style",
        })}
      </span>
      <div className="flex flex-col gap-6">
        {/* TODO: Uncomment after implementing dark theme */}
        {/* <Controller
          control={control}
          name="theme"
          render={({ field: { value, onChange } }) => (
            <ChatBotThemePicker value={value} onChange={onChange} />
          )}
        /> */}
        <Controller
          control={control}
          name="senderMessageBackgroundColor"
          render={({ field: { value, onChange } }) => (
            <ColorPickerPopover
              title={value}
              color={value}
              onColorChange={onChange}
              renderTrigger={({ Trigger, triggerRef }) => (
                <Trigger
                  ref={triggerRef}
                  as={InteractiveContainer}
                  className="flex h-[60px] items-center gap-3 rounded-[10px] border border-solid border-grey-400 px-5 font-secondary text-sm text-black"
                >
                  <div
                    className="h-6 w-6 rounded-md"
                    style={{ backgroundColor: value }}
                  />
                  <span>
                    {t({
                      id: "cx-ai-agents-page.sender-message-color",
                      defaultMessage: "Sender message color:",
                    })}
                  </span>
                  <span>{value}</span>
                </Trigger>
              )}
            />
          )}
        />
      </div>
    </div>
  );
};
